import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-components-specialist-actioncomponents-rejection',
  templateUrl: './rejection.component.html'
})
export class RejectionComponent {
  @Input() rejection: Boo.Objects.Rejection;
}
